import React from "react";
// import HeroImg from "./assets/images/hero-about.png";
import Bg from "./assets/images/aboutBg.png";
import NurseGroup from "./assets/images/nursegroup.png";
import Television from "./assets/icons/television.png";
import Shield2 from "./assets/icons/shield.png";
import Bag from "./assets/icons/bag2.png";
import Arrow from "./assets/icons/arrow.png";
// import Testimonials from "./components/Testimonials";
import Pipette from "./assets/icons/pipette.png";
import Shield from "./assets/icons/shield (2).png";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const About = () => {
  const stories = [
    {
      id: 1,
      type: "Excellence",
      icon: Pipette,
      description: "Highest quality standards",
    },
    {
      id: 2,
      type: "Innovation",
      icon: Television,
      description: "Cutting-edge technology",
    },
    {
      id: 3,
      type: "Patient Care",
      icon: Shield,
      description: "Compassionate service",
    },
    {
      id: 4,
      type: "Reliability",
      icon: Shield2,
      description: "Accurate results",
    },
  ];

  const services = [
    {
      id: 1,
      icon: Shield,
      service: "Laboratory Testing",
      description: "Comprehensive blood work and specialized laboratory tests",
    },
    {
      id: 2,
      icon: Bag,
      service: "Imaging Services",
      description: "Advanced imaging including X-ray, MRI, and CT scans",
    },
    {
      id: 3,
      icon: Shield2,
      service: "Preventive Screenings",
      description: "Regular health screenings and preventive care",
    },
    {
      id: 4,
      icon: Pipette,
      service: "Specialized Diagnostics",
      description: "Advanced diagnostic procedures and specialized testing",
    },
  ];
  return (
    <div>
      {/* hero-section */}
      <section
        style={{ backgroundImage: `url(${Bg})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        {/* <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[80vh] w-full absolute top-0"></div> */}
        <div
          data-aos="fade-in"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="z-10 lg:px-24 md:px-10 px-4 "
        >
          <div className="lg:w-[55%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl  text-3xl text-white font-semibold md:leading-[3.5rem]">
              About Clear-Icon Medic Diagnostics Lab
            </h1>
            <p className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full">
              At Clear-Icon Medic Diagnostics Lab, we're dedicated to providing
              high-quality diagnostic services that help healthcare
              professionals make informed decisions. With a passion for
              innovation and a commitment to excellence, we've built a
              reputation for reliability, accuracy, and patient care
            </p>
          </div>
        </div>
      </section>

      <section className="lg:px-24 md:px-10 px-4 py-10">
        <h1 className="text-primaryPurple py-4 text-center md:text-2xl lg:text-3xl text-3xl font-bold">
          About Us
        </h1>
        <p className="text-center text-gray-600 pb-14">
          Leading the Future of Medical Diagnostics
        </p>
        <div className=" flex flex-col lg:flex-row items-center gap-10 justify-between">
          <div className=" lg:w-[50%] order-1 lg:order-2">
            <h1 className="text-primaryPurple md:text-2xl lg:text-2xl text-2xl font-bold">
              Our Mission
            </h1>
            <p
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-duration="1000"
              className="text-gray-600 py-3 text-sm leading-[1.6rem]"
            >
              Founded in 2020, Clear-Icon Medic Diagnostics has been at the
              forefront of medical innovation, providing cutting-edge diagnostic
              solutions to healthcare providers and patients alike.
            </p>
            <p
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-duration="1000"
              className="text-gray-600 py-3 text-sm leading-[1.6rem]"
            >
              Our mission is to make advanced medical diagnostics accessible,
              accurate, and efficient through state-of-the-art technology and
              expert medical professionals.
            </p>

            <div
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-duration="1000"
              className="grid-flow-row text-sm grid text-gray-600 grid-cols-3 gap-5"
            >
              <div className="flex flex-col text-center items-center gap-2">
                <h1 className="text-xl  font-semibold text-primaryPurple">
                  3+
                </h1>
                <p>Years Experience</p>
              </div>
              <div className="flex text-center flex-col items-center gap-2">
                <h1 className="text-xl font-semibold text-primaryPurple">
                  50k+
                </h1>
                <p>Patients Served</p>
              </div>
              <div className="flex text-center flex-col items-center gap-2">
                <h1 className="text-xl font-semibold text-primaryPurple">
                  50+
                </h1>
                <p>Expert Doctors</p>
              </div>
            </div>
          </div>
          <div className=" lg:w-[50%] order-2 lg:order-1">
            <img src={NurseGroup} alt="" />
          </div>
        </div>
      </section>

      <section
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="lg:px-24 bg-lightGrey md:px-10 px-4 py-10"
      >
        <h1 className="text-primaryPurple py-4 text-center md;w-[70%] w-full mx-auto md:text-2xl lg:text-3xl text-3xl font-bold">
          Leading the Way in Medical Diagnostics
        </h1>
        <p className="text-center text-sm md:text-base w-[90%] mx-auto md:w-[50%] text-gray-600 pb-14">
          Delivering excellence in medical diagnostics with cutting-edge
          technology and compassionate care
        </p>
        <div className=" flex flex-col lg:flex-row items-center gap-10 justify-between">
          <div className=" lg:w-[50%] order-1 lg:order-2">
            <h1 className="text-primaryPurple md:text-2xl lg:text-2xl text-2xl font-bold">
              Our Story
            </h1>
            <p className="text-gray-600 py-3 text-sm leading-[1.6rem]">
              Founded in 2010, Clear-Icon Medic Diagnostics has been at the
              forefront of medical diagnostics, combining advanced technology
              with compassionate care to provide accurate and reliable results
              to our patients.
            </p>
            <p className="text-gray-600 py-3 text-sm leading-[1.6rem]">
              Our mission is to make high-quality diagnostic services accessible
              to everyone while maintaining the highest standards of medical
              excellence and patient care.
            </p>
          </div>
          <div className=" lg:w-[50%] order-2 lg:order-1">
            <img src={NurseGroup} alt="" />
          </div>
        </div>
      </section>

      <div
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="grid place-items-center lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:px-24 bg-lightGrey md:px-10 px-4 py-10 gap-3 mx-auto max-w-full  "
      >
        {stories?.map((item) => (
          <div
            key={item?.id}
            className="flex text-center lg:w-[16rem] md:w-[20rem] w-[22rem] h-[10rem] flex-col items-center gap-2 bg-white rounded-lg py-8 px-6"
          >
            <img src={item?.icon} className="w-[2rem]" alt="" />
            <h1 className="font-semibold">{item?.type}</h1>
            <p className="text-gray-600 text-sm">{item?.description}</p>
          </div>
        ))}
      </div>

      <section className="lg:px-24 bg-lightGrey md:px-10 px-4 py-10">
        <div
          data-aos="fade-up"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="text-primaryPurple py-4 text-center md;w-[70%] w-full mx-auto md:text-2xl lg:text-3xl text-3xl font-bold"
        >
          Our Diagnostic Services
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="text-center text-sm md:text-base w-[90%] mx-auto md:w-[50%] text-gray-600 pb-14"
        >
          Comprehensive range of diagnostic services to meet your healthcare
          needs
        </div>

        <div className="w-full bg-lightGrey">
          <div className="grid place-items-center lg:grid-cols-2  md:grid-cols-2 grid-cols-1  gap-3 max-w-full  ">
            {services?.map((item) => (
              <div
                key={item?.id}
                className="flex md:w-[20rem] lg:w-[35rem] w-[22rem] h-[13rem] flex-col  gap-2 bg-white rounded-lg py-8 px-6"
              >
                <img src={item?.icon} className="w-[2rem]" alt="" />
                <h1 className="font-semibold text-primaryPurple">
                  {item?.service}
                </h1>
                <p className="text-gray-600 text-sm">{item?.description}</p>
                <p className="pt-5 flex items-center gap-2">
                  <p className="text-[0.75rem] text-primaryPurple">
                    Learn more
                  </p>
                  <img
                    src={Arrow}
                    className="w-[0.8rem] font-semibold"
                    alt=""
                  />
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <Testimonials /> */}
      <div className="bg-lightGrey py-16"></div>
    </div>
  );
};

export default About;
